module.exports = __webpack_public_path__ + "static/media/evening.ad1dc9a1.svg";